import { IRisikoSection } from "@schemas/issueBoardSchema";
import { IOtherAttributeConfigApi } from "@schemas/otherAttributesSchema";
import React from "react";
import { FailedAlert } from "../../../../../../../components";
import HistoryLogsTableDeprecated from "../../../../../../../components/HistoryLogsTable/HistoryLogsTableDeprecated";
import { useGetIssueHistoryLogsQuery } from "../../../../issueRTK";

const IssueHistoryLogs: React.FC<{
  projectId: string;
  issueId: string;
  otherAttributesConfig: IOtherAttributeConfigApi;
  risikoConfig: IRisikoSection;
}> = ({ projectId, issueId, otherAttributesConfig, risikoConfig }) => {
  const {
    data: logs = [],
    isLoading: logsLoading,
    isError,
  } = useGetIssueHistoryLogsQuery({
    projectId,
    issueId,
  });

  return (
    <div>
      {isError === true && <FailedAlert />}
      <HistoryLogsTableDeprecated
        logData={logs}
        otherAttributesConfig={otherAttributesConfig}
        risikoConfig={risikoConfig}
      />
    </div>
  );
};

export default IssueHistoryLogs;
